module.exports = __webpack_public_path__ + "static/media/ios-return-left.20f93ed6.svg";